(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/shared-components/doc-list.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/shared-components/doc-list.js');
'use strict';

const DocItem = svs.termsIntegrity.sharedComponents.DocItem;
const ListGroup = svs.ui.ReactListGroup.ListGroup;
const DocList = _ref => {
  let docList = _ref.docList;
  return React.createElement(ListGroup, {
    className: "terms-integrity-lists"
  }, docList && docList.length > 0 && docList.map(item => React.createElement(DocItem, {
    docItem: item,
    key: item.id
  })));
};
svs.termsIntegrity.sharedComponents.DocList = DocList;

 })(window);